// extracted by mini-css-extract-plugin
module.exports = {"container":"listsubcategory_container__1VRRR"};